import type { Moment } from 'moment';
import moment from 'moment';

export const getDurationByStartAndEndDates = (start: Moment | null, end: Moment | null): number | null => {
  if (!start || !end) return null;
  const minutes = moment(end).diff(start, 'minutes');
  return Number(((minutes * 1000) / 60 / 24 / 1000).toFixed(3));
};
